import { render, staticRenderFns } from "./yxnh.vue?vue&type=template&id=b68e1098&scoped=true&"
import script from "./yxnh.vue?vue&type=script&lang=js&"
export * from "./yxnh.vue?vue&type=script&lang=js&"
import style0 from "./yxnh.vue?vue&type=style&index=0&id=b68e1098&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68e1098",
  null
  
)

export default component.exports